import React, {useContext, useState} from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Grid} from "@material-ui/core";
import InputField from "../../../FormikUtils/InputField";
import {ErrorMessage, Field, useFormikContext} from "formik";
import LogoUploader from "../../../../manager/LogoUploader";
import CheckboxField from "../../../FormikUtils/CheckboxField";
import {CheckPicker} from 'rsuite';
import MasterContext from "../../../../../context/MasterContext";
import RegularInputField from "../../../../RegularInputField";
import SlantedField from "../../../FormikUtils/SlantedField";
import SelectField from "../../../FormikUtils/SelectField";
import NumberField from "../../../FormikUtils/NumberField";


const useStyle = makeStyles(() => ({
    errorMessage: {
        color: "red",
        fontSize: "12px",
        textAlign: "center",
        marginTop: "-8px"
    },
    titulo: {
        fontSize: '24px',
        color: '#35303f',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        letterSpacing: '-0.75'

    },
    subtitulo: {
        fontSize: '14px',
        color: '#8a8597',
        fontFamily: 'Nunito',
        textAlign: ' justify',
    },
    divRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    divColumn: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "30%",
    },
    divColumn1: {
        display: "flex",
        flexDirection: "column",
        width: "65%",
    }

}))


function AffinityForm(props) {
    const handleOpenAlert = props.handleOpenAlert;
    const classes = useStyle();
    const {advisers, unidadesNegocioOptions} = useContext(MasterContext)

    const adviserCodes = advisers;
    const [affinityName, setAffinityName] = useState(null);
    const {setFieldValue, values, errors} = useFormikContext();

    const {
        formField: {
            company_name,
            business_name,
            managerAffinity_mail,
            managerAffinity_name,
            managerAffinity_lastName,
            managerAffinity_phone,
            company_logo,
            intermediary_code,
            adviser_phone,
            organizer_code,
            assigned_advisers,
            activated_products,
            extra_discount,
            model_discount,
            business_unit,
            giftcard_amount,
            commercial_condition,
            commercial_description,
            statistic_group,
        },
        isEdit
    } = props;

    const handleChangePicker = (adviser) => {
        setFieldValue(assigned_advisers.name, adviser)
    }

    const hasCommercialConditionsOptions = [
        {value: 'SI', label: 'Si'},
        {value: 'NO', label: 'No'}
    ];

    return (
        <React.Fragment>
            <div className={classes.divRow}>
                <div className={classes.divColumn}>

                    <LogoUploader affinityName={affinityName} handleOpenAlert={handleOpenAlert} name={company_logo.name}
                                  defaultImage={values.company_logo}
                                  label={company_logo.label}/>

                    <div style={{marginTop: "16px", width: "200px"}}>
                        <InputField name={adviser_phone.name} label={adviser_phone.label}
                                    fullWidth textTransform={'uppercase'} placeholder={'Sin el 0 y sin el 15'}/>
                    </div>

                    <div style={{marginTop: "24px", width: "200px"}}>
                        <SelectField
                            name={business_unit.name}
                            label={business_unit.label}
                            data={unidadesNegocioOptions}
                            fullWidth
                        />
                    </div>

                    <div style={{marginTop: "16px", width: "200px"}}>
                        <SelectField
                            name={commercial_condition.name}
                            label={commercial_condition.label}
                            data={hasCommercialConditionsOptions}
                            fullWidth
                        />
                    </div>

                    {values.commercial_condition === "SI" &&
                    <>
                        <div style={{marginTop: "16px", width: "200px"}}>
                            <NumberField
                                notCobertura={true}
                                errorText={errors.giftcard_amount}
                                name={giftcard_amount.name}
                                label={giftcard_amount.label}
                                inputProps={{style: {textAlign: 'right'}}}
                            />
                        </div>
                        <div style={{marginTop: "8px", width: "200px"}}>
                            <InputField
                                name={commercial_description.name}
                                label={commercial_description.label}
                                multiline
                                rows={3}
                                fullWidth textTransform={'capitalize'}
                            />
                        </div>
                    </>
                    }

                </div>
                <div className={classes.divColumn1}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <InputField name={company_name.name} label={company_name.label} fullWidth
                                        setAffinityName={setAffinityName} textTransform={'capitalize'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputField name={business_name.name} label={business_name.label} fullWidth
                                        textTransform={'capitalize'}/>
                        </Grid>

                        {isEdit
                            ?
                            <>
                                <Grid item xs={12} sm={6}>
                                    <SlantedField value={values.intermediary_code} label={intermediary_code.label}/>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <InputField name={organizer_code.name} label={organizer_code.label} fullWidth
                                                textTransform={'uppercase'}/>
                                </Grid>
                            </>
                            :
                            <>
                                <Grid item xs={12} sm={6}>
                                    <InputField name={intermediary_code.name} label={intermediary_code.label} fullWidth
                                                textTransform={'uppercase'}/>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <InputField name={organizer_code.name} label={organizer_code.label} fullWidth
                                                textTransform={'uppercase'}/>
                                </Grid>
                            </>
                        }

                        <Grid item xs={12} sm={6}>
                            <InputField name={managerAffinity_name.name} label={managerAffinity_name.label} fullWidth
                                        textTransform={'capitalize'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputField name={managerAffinity_lastName.name} label={managerAffinity_lastName.label}
                                        fullWidth textTransform={'capitalize'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputField name={managerAffinity_mail.name} label={managerAffinity_mail.label} fullWidth
                                        textTransform={'lowercase'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputField name={managerAffinity_phone.name} label={managerAffinity_phone.label}
                                        fullWidth textTransform={'uppercase'} placeholder={'Sin el 0 y sin el 15'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <RegularInputField name={statistic_group.name} label={statistic_group.label}
                                               fullWidth/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <RegularInputField name={model_discount.name} label={model_discount.label}
                                               fullWidth/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <RegularInputField name={extra_discount.name} label={extra_discount.label}
                                               fullWidth/>
                        </Grid>

                        <Grid item xs={12} sm={12} container spacing={1} >
                            <Grid item xs={12} sm={12} container direction="row" justifyContent="center">
                                <Grid item xs={12} sm={6}><Field component={CheckboxField}
                                                                 name={activated_products.name}
                                                                 value="0" label="Automotor"/></Grid>
                                <Grid item xs={12} sm={6}><Field component={CheckboxField}
                                                                 name={activated_products.name}
                                                                 value="1" label="Motovehículo"/></Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} container direction="row" justifyContent="center">
                                <Grid item xs={12} sm={6}> <Field
                                    component={CheckboxField}
                                    name={activated_products.name}
                                    value="2" label="Hogar"/></Grid>
                                <Grid item xs={12} sm={6}><Field component={CheckboxField}
                                                                 name={activated_products.name}
                                                                 value="3" label="Microseguros"/> </Grid>

                            </Grid>
                            <Grid item xs={12} sm={12} container direction="row" justifyContent="center">
                                <Grid item xs={12} sm={6}> <Field
                                    component={CheckboxField}
                                    name={activated_products.name}
                                    value="4" label="Otros Seguros"/></Grid>
                                <Grid item xs={12} sm={6}><Field component={CheckboxField}
                                                                 name={activated_products.name}
                                                                 value="5" label="Prevención Salud"/> </Grid>
                                <Grid item xs={12} sm={6}/>
                            </Grid>
                            {errors.activated_products &&
                                <Grid item xs={12}>
                                    <ErrorMessage name='activated_products'
                                                  render={msg => <div className={classes.errorMessage}>{msg}</div>}/>
                                </Grid>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <CheckPicker sticky
                                         onChange={handleChangePicker}
                                         data={adviserCodes}
                                         defaultValue={values.assigned_advisers}
                                         block
                                         placeholder={assigned_advisers.label}/>
                        </Grid>
                        {errors.assigned_advisers &&
                            <Grid item xs={12}>
                                <ErrorMessage name='activated_products'
                                              render={msg => <div className={classes.errorMessage}>{msg}</div>}/>
                            </Grid>
                        }
                    </Grid>
                </div>
            </div>
        </React.Fragment>
    );
}

export default AffinityForm;